import * as React from 'react';
import { useIntl } from 'react-intl';
import * as styles from './BackButton.module.scss';
import Icon from './assets/back.inline.svg';
import DesktopIcon from './assets/back.desktop.inline.svg';
import useStep from '../../hooks/useStep';

export default function BackButton(): React.ReactElement {
    const intl = useIntl();
    const { back } = useStep(false);

    const handleClick = React.useCallback(
        (event: React.MouseEvent<HTMLButtonElement>) => {
            event.preventDefault();
            back();
        },
        [back],
    );

    return (
        <button type="button" onClick={handleClick} className={styles.root}>
            <Icon className={styles.icon} />
            <DesktopIcon className={styles.iconDesktop} />
            <span>{intl.formatMessage({ id: 'booking.back' })}</span>
        </button>
    );
}
